import {FileUpload} from 'components/FileUpload';
import {connect} from 'react-redux';
import {Button, Icon} from 'semantic-ui-react';
import {uploadTestimonialImage} from 'ducks/testimonials';

const mapStateToProps = (state) => {
  return {
    header: <div><Icon name="image" color="grey" size="huge"/>
      <div className="add-image-instruction">Add a property image</div>
    </div>,
    description: <Button primary className="upload-image-button">Upload</Button>,
    accept: 'image/png, image/jpeg',
    uploadProgress: state.uploadProgress,
    uploadText: 'Uploading testimonial\'s image...',
    propertyId: state.propertyDetail.propertyId,
    className: 'select-image upload-image',
    testimonial: state.testimonial,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onUpload: (files) => {
      const testimonial = ownProps.testimonial;
      dispatch(uploadTestimonialImage(testimonial, files[0], ownProps.onFileUpload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);